'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const DetailsItem = require('./DetailsItem');
const DetailsMaterialAndTechniques = require('./DetailsMaterialsAndTechniques');
const DetailsDimensions = require('./DetailsDimensions');
const DetailsMultiline = require('./DetailsMultiline');
const findNameSpace = require('find-namespace-value');
const detailsConstants = require('../../constants/detailsConstants.es.js');

class DetailsItems extends ContextComponent {
    constructor(props) {
        super(props);
    }

    /**
     * This component takes three props
     *   detailsConfig - see definition in detailsConfig {@link newPdp/details/detailsConfig}
     *   detailsTitles - see definition for detailsTitles in ItemStore {@link newPdp/stores/ItemStore}
     *   details       - see defintion for getDetails in ItemStore {@link newPdp/stores/ItemStore}
     *
     * And in render calls the array map method on detailsConfig, at each step using an object
     * in the array to determine what component to use to render a detail as well as what information
     * to pass to that component from detailsTitles and details.
     */
    render() {
        const details =
            this.props.detailsConfig
            .map((config) => {
                return {
                    title: findNameSpace(config.title, this.props.detailsTitles),
                    contents: findNameSpace(config.contents, this.props.details),
                    component: config.component,
                    gaLabel: config.gaLabel,
                    testName: config.testName
                };
            })
            .filter((results) => {return results.title && results.contents;})
            .map((results, i) => {
                if (results.component && results.component === findNameSpace('components.materialsAndTechniques', detailsConstants)) {
                    return <DetailsMaterialAndTechniques {...results} key={i} isPrintPage={this.props.isPrintPage} />;
                } else if (results.component && results.component === findNameSpace('components.dimensions', detailsConstants)) {
                    return <DetailsDimensions {...results} key={i} />;
                } else if (results.component && results.component === findNameSpace('components.multiline', detailsConstants)) {
                    return <DetailsMultiline {...results} key={i} isPrintPage={this.props.isPrintPage} />;
                } else {
                    return <DetailsItem {...results} key={i} isPrintPage={this.props.isPrintPage} />;
                }
            });

        const detailsSize = Object.keys(this.props.details).length;
        const detailsSizeHalf = Math.ceil(detailsSize / 2);

        let detailsFirstHalf;
        let detailsSecondHalf;

        if (detailsSize <= 5) {
            // If there are five details, all the details should appear in the left column.
            detailsFirstHalf = details;
        } else if (detailsSize <= 10) {
            // If there are five to ten details, the first five should appear in the left
            // column and the remaining should appear on the right column.
            detailsFirstHalf = details.slice(0, 5);
            detailsSecondHalf = details.slice(5);
        } else {
            // If there are more than ten details, an even amount should appear on
            // the left and right columns.
            detailsFirstHalf = details.slice(0, detailsSizeHalf);
            detailsSecondHalf = details.slice(detailsSizeHalf);
        }

        return (
            <div className="pdp-details-entries colXs12">
                <div className="rowFlexTransition">
                    <ul className="pdp-details-entries-column colXs12 colLg6">
                        {detailsFirstHalf}
                    </ul>
                    <ul className="pdp-details-entries-column colXs12 colLg6">
                        {detailsSecondHalf}
                    </ul>
                </div>
            </div>
        );
    }
}

DetailsItems.defaultProps = {
    isPrintPage: false
};

DetailsItems.propTypes = {
    details: PropTypes.object.isRequired,
    detailsTitles: PropTypes.object.isRequired,
    detailsConfig: PropTypes.array.isRequired,
    isPrintPage: PropTypes.bool
};

module.exports = DetailsItems;



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/components/DetailsItems.jsx